"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = autocompleteReducer;

var _immutable = require("immutable");

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _searchBarUtils = require("../utils/searchBarUtils");

var initialState = (0, _immutable.fromJS)({
  showMenu: false,
  resultsToDisplay: [],
  resultsIndex: {}
});

function autocompleteReducer() {
  var autocomplete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.UPDATE_AUTOCOMPLETE_MENU:
      return autocomplete.merge({
        showMenu: true,
        resultsToDisplay: (0, _searchBarUtils.parseAutocompleteResults)(action.payload),
        resultsIndex: (0, _searchBarUtils.populateAutocompleteResultsIndex)(action.payload)
      });

    case _ActionTypes.default.HIDE_AUTOCOMPLETE_MENU:
      return initialState;

    default:
      return autocomplete;
  }
}

module.exports = exports.default;